import {Component, computed, inject, OnInit} from '@angular/core';
import {CatalogStore} from '@store/catalog.store';
import {MatButton} from '@angular/material/button';
import {ClpFormatPipe} from '@shared/pipes/clp/clp-format-pipe';
import {Router} from '@angular/router';
import {StorageService} from '@services/storage.service';
import {BillResponse} from '@core/models';
import {SessionStore} from '@store/session.store';
import {LucideCircleCheckBig} from '@lucide/angular';
import {CART_KEY} from '@core/constants';


@Component({
  selector: 'app-success',
  standalone: true,
  imports: [
    MatButton,
    ClpFormatPipe,
    LucideCircleCheckBig,
  ],
  templateUrl: './success.html',
  styleUrl: './success.scss',
})
export class Success implements OnInit {
  private readonly router = inject(Router);
  private readonly storage = inject(StorageService);
  private readonly store = inject(CatalogStore);
  private readonly sessionStore = inject(SessionStore);

  protected readonly billData = computed(() => this.sessionStore.orderDetails() as BillResponse);
  protected selectedTable = this.sessionStore.selectedTable;

  ngOnInit() {
    this.store.setHeaderVisibility(false);

    // Remoción selectiva de las llaves del flujo de la orden en lugar de limpiar todo el almacenamiento
    sessionStorage.removeItem('current_order_id');
    sessionStorage.removeItem('current_customer_id');
    localStorage.removeItem(CART_KEY);
  }

  async goToMenu() {
    sessionStorage.clear();
    localStorage.clear();

    this.sessionStore.resetSession();
    const newTree = this.router.createUrlTree(['/splash']);

    await this.router.navigateByUrl(newTree, {replaceUrl: true});
    window.location.reload();
  }
}
